import 'index.scss';
import './components/_lang';
import './components/_fontSize';
import { lazyloadFn } from './components/_lazyload';

const winW = $(window).width();
const winH = $(window).height();
const controller = new ScrollMagic.Controller();

$(document).ready(function() {


    //--------------------- ScrollMagic ---------------------//


    var tween = new TimelineMax()
        .from('.kv_sec', .6, { opacity: 0, ease: Circ.easeOut })

    new ScrollMagic.Scene({ offset: 0 })
        .setTween(tween)
        .addTo(controller);



    let param = { triggerElement: "#trigger-intro" };
    if (winW <= 768) param = { offset: 0 };

    var tween = new TimelineMax()
        .from('.intro_title', .8, { y: 10, opacity: 0, ease: Quart.easeOut })
        .staggerFrom('.intro_txt p', .8, { y: 10, opacity: 0, ease: Quart.easeOut }, .15, '-=.6')

    new ScrollMagic.Scene(param)
        .setTween(tween)
        .addTo(controller);



    let param2 = { triggerElement: "#trigger-grid", triggerHook: 1 };
    if (winW <= 768) param2 = { triggerElement: "#trigger-intro", triggerHook: 1 };

    var tween = new TimelineMax()
        .staggerFrom('.grid-item', 1.1, { y: 150, opacity: 0, ease: Quart.easeOut }, .15)

    new ScrollMagic.Scene(param2)
        .setTween(tween)
        .addTo(controller);





    //--------------------- imagesLoaded ---------------------//
    function removeLoading() {
        $(".loading").fadeOut(function() {
            $(this).remove();
            lazyloadFn();

            $('.grid').masonry({
                itemSelector: '.grid-item',
                columnWidth: '.grid-sizer',
                percentPosition: true
            });
        });
    }

    imagesLoaded("html, body", function() {
        removeLoading();
    });
});